module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8sMqB"))).then(() => parcelRequire('d0iPb'));